import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"Apostille ทะเบียนสมรสไทย — ใช้ต่างประเทศ 130 ประเทศ","metaTitle":"Apostille ทะเบียนสมรส (คร.2/คร.3) — 5-7 วัน | NYC","metaDesc":"แปล + MFA + Apostille ทะเบียนสมรสไทย (คร.2/คร.3) ใช้ยื่นวีซ่าคู่สมรส เปลี่ยนนามสกุล ประกันสังคม รับมรดกใน 1 — คุยกับผู้เชี่ยวชาญตัวจริง ตอบกลับภายในไม่กี่นาที"},"en":{"h1":"Apostille Thai Marriage Certificate — 125 Hague Countries","metaTitle":"Thai Marriage Certificate Apostille (Kor Ror 2/3) | NYC","metaDesc":"Translation + MFA + Apostille of Thai Kor Ror 2 & 3 for in 5-7 days. Required for spouse visas, name — Get your timeline and checklist in minutes — chat now."}} as const;

export const Route = createFileRoute("/apostille/marriage-certificate")({
  head: () => {
    const url = `${SEO_SITE}/apostille/marriage-certificate`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/apostille/marriage-certificate", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/apostille/marriage-certificate", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/apostille/marriage-certificate", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/apostille/marriage-certificate", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/apostille/marriage-certificate", "/en/apostille/marriage-certificate")],
    };
  },
  component: () => <SubServicePage slug="apostille/marriage-certificate" locale="th" />,
});
